import {InjectionToken} from '@angular/core';
import {IToastToken} from './toast-token';

export type TProgressAnimation = 'increasing' | 'decreasing';
export type TDisableTimOut = boolean | 'timeOut' | 'extendedTimeOut';

export const TOAST_CONFIG = new InjectionToken<IToastToken>('ToastConfig');
